// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"rightArrow_mainComponent__dr4Md"};